export const developers = [
    { name: 'Meraas', summary: 'Design-led developer behind Bluewaters, City Walk', img: '/Meraas.jpg' },
    { name: 'Deyaar', summary: 'Master developer of iconic communities like Downtown Dubai', img: '/Emaar.jpg' },
    { name: 'Damac', summary: 'Luxury apartments, villas & branded residences', img: '/Damac.jpg' },
    { name: 'Danube', summary: 'Creators of Palm Jumeirah and waterfront living', img: '/Nakheel.jpg' },
    { name: 'Dubai South', summary: 'Sophisticated mixed-use lifestyle projects', img: '/pic1.jpg' },
    { name: 'Binghatti', summary: 'Premium developer known for Madinat Jumeirah Living & Sobha Hartland', img: '/Sobha.png' },
];
